<template>
  <div class="acc-alerts">
    <div class="tile-title">
      <span>
        <input v-if='showCheckbox' v-model="checkBoxState" type="checkbox" @click="clickEvent">
        {{ label }}
      </span>
    </div>
    <br>
    <slot></slot>
    <br>
  </div>
</template>

<script>
export default {
  name: 'BorderedContainer',
  props: {
    label: {
      type: String,
      required: true
    },

    showCheckbox: {
      type: Boolean,
      required: false,
      default: false
    },

    initState: {
      type: Boolean,
      required: true
    }

  },

  data() {
    return {
      checkBoxState: false
    }
  },

  mounted() {
    this.checkBoxState = this.initState
  },

  methods: {
    clickEvent() {
      this.$emit('clickEvent', this.checkBoxState)
    }
  }
}
</script>

<style lang="scss" scoped>
  .acc-alerts {
    border: solid 2px;
    position: relative;
    padding: 0 1em;
    .tile-title {
      position: absolute;
      top: -15px;
      left: 10px;
      background: white;
      font-size: 18px;
      font-weight: 400;
      padding: 0 .25em;
    }
  }
</style>